export const lightTheme = {
    body: '#E5E5E5',
    text: '#000000',
    containerbg: '#DBDBDB',
    circularIconBg: '#000000',
    circularIconTextBg: '#ffffff',
    skillSetBg: '#D9D9D9',
    selectedOption: '#23262c',
    galleryBg: '#E0E0E0',
    ripplebg: 'rgba(255, 255, 255, 0.2)',
    bubbleHoverClr: 'rgba(217, 217, 217, 0.19)',
    shadowColor: 'rgba(0, 0, 0, 0.2)',
    textShadowColor: 'rgba(0, 0, 0, 0.3)',
    planetBorder: '#D4D4D4',
    placeHolderDateHover: "1px 1px 3px white",
    datesHover:  'rgba(255, 255, 255, 0.4)',
    gradientDatesHover:  "linear-gradient(rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.1))",
    yearsGradientDatesHover:  "linear-gradient(rgba(255, 255, 255, 0.4), rgba(255, 255, 255, 0.4))",
    checkBoxLightHover: 'rgba(255, 255, 255, 0.7)',
    loginCoverDiv: "#dedede",
    searchInputBcg: "#E0E0E0",
    searchInputBdrClr: "#b1b1b1",
    searchInputBdrClrHver: "rgba(0, 0, 0, 0.4)",
    searchInputBcgClrHver: "#ccc",
    tinMenuHover: 'rgba(255, 255, 255, 0.8)',
    shadowBox: "0px 1px 12px 1.5px rgba(0, 0, 0, 0.2)",
  };
   
  export const darkTheme = { 
    body: '#181a1e',
    text: '#ffffff',
    containerbg: '#1C1D20', 
    circularIconBg: '#ffffff',
    circularIconTextBg: '#000000',
    skillSetBg: '#23262c',
    selectedOption: '#D9D9D9',
    galleryBg: '#181b1e',
    ripplebg: 'rgba(0, 0, 0, 0.2)',
    bubbleHoverClr: 'rgba(35, 38, 38, 0.19)',
    shadowColor: 'rgba(255, 255, 255, 0.2)',
    textShadowColor: 'rgba(255, 255, 255, 0.3)',
    planetBorder: '#21222a',
    placeHolderDateHover: "3px 3px 3px black",
    datesHover:  'rgba(0, 0, 0, 0.2)',
    gradientDatesHover:  "linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1))",
    yearsGradientDatesHover:  "linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3))",
    checkBoxLightHover: 'rgba(0, 0, 0, 0.7)',
    loginCoverDiv: "#1c1d20",
    searchInputBcg: "#1c1d20",
    searchInputBdrClr: "#23262c",
    searchInputBdrClrHver: "rgba(255, 255, 255, 0.3)",
    searchInputBcgClrHver: "#23262c",
    tinMenuHover: 'rgba(0, 0, 0, 0.2)',
    shadowBox: "0px 1px 12px 1.5px rgba(0, 0, 0, 0.4)",
  };
